import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { WawiApiNoteFacilityCreateFormComponent } from "./note-facility/create/form/note-facility-create-form.component";
import { WawiApiNoteFacilityCreateDialogComponent } from "./note-facility/create/note-facility-create-dialog.component";
import { WawiApiNoteFacilityUpdateFormComponent } from "./note-facility/update/form/note-facility-update-form.component";
import { WawiApiNoteFacilityUpdateDialogComponent } from "./note-facility/update/note-facility-update-dialog.component";
import { WawiApiNoteFacilityExtendedFilterComponent } from "./note-facility/extended-filter/note-facility-extended-filter.component";

@NgModule({
  imports: [
    CommonComponentsModule,
  ],

  declarations: [
    WawiApiNoteFacilityCreateFormComponent,
    WawiApiNoteFacilityCreateDialogComponent,
    WawiApiNoteFacilityUpdateDialogComponent,
    WawiApiNoteFacilityUpdateFormComponent,
    WawiApiNoteFacilityExtendedFilterComponent,
  ],

  exports: [
    WawiApiNoteFacilityCreateFormComponent,
    WawiApiNoteFacilityCreateDialogComponent,
    WawiApiNoteFacilityUpdateDialogComponent,
    WawiApiNoteFacilityUpdateFormComponent,
  ],
})
export class WawiApiNotesModule {}